import React from 'react';
import PropTypes from 'prop-types';

const HomePlannerIcon = ({ dashArray, dashOffset, opacity, showStar }) => {
  return (
    <svg
      width="192"
      height="192"
      viewBox="0 0 192 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_7014_191886)">
        <circle cx="96" cy="92" r="80" fill="white" />
        <circle
          cx="96"
          cy="92"
          r="77"
          stroke={showStar ? '#E4E5E7' : 'white'}
          strokeWidth="6"
        />
      </g>
      <circle
        className="progressBar"
        cx="96"
        cy="92"
        r="77"
        fill="transparent"
        strokeWidth="6"
        stroke="#FFC50A"
        strokeDasharray={dashArray || ''}
        strokeDashoffset={dashOffset || ''}
        strokeLinecap="butt"
      />
      <circle cx="96" cy="92" r="65" fill="#E2F7FF" />

      {showStar && <circle cx="96" cy="19" r="15" fill="#FFC50A" />}
      <path
        d="M94.064 16.621L95.4667 13.7787C95.6501 13.4071 96.18 13.4071 96.3634 13.7787L97.7661 16.621L100.902 17.0762C101.312 17.1357 101.476 17.6397 101.179 17.929L98.9103 20.1415L99.4459 23.2655C99.5159 23.674 99.0871 23.9855 98.7203 23.7925L95.9151 22.317L93.1098 23.7925C92.743 23.9855 92.3142 23.674 92.3842 23.2655L92.9198 20.1415L90.651 17.929C90.3543 17.6397 90.5181 17.1357 90.9282 17.0762L94.064 16.621Z"
        fill="white"
      />
      <g opacity={opacity}>
        <path
          d="M58 116.087H78.1779V132.002H64.8092C61.0414 132.002 58 128.938 58 125.142V116.087V116.087Z"
          fill="#003381"
        />
        <path
          d="M78.1777 72.915H57.9999V63.8602C57.9999 60.0644 61.0413 57.0004 64.809 57.0004H71.3685C75.1363 57.0004 78.1777 60.0644 78.1777 63.8602V72.915Z"
          fill="#003381"
        />
        <path
          d="M123.073 57.001H64.9678C66.0572 57.0924 71.777 60.065 71.777 63.8607V125.141C71.777 128.937 68.7355 132.001 64.9678 132.001H123.073C126.841 132.001 129.882 128.937 129.882 125.141V63.8607C129.882 60.065 126.841 57.001 123.073 57.001Z"
          fill="#0075C9"
        />
        <path
          d="M111.861 116.957L104.008 117.597L104.643 109.663L130.473 83.6416L137.691 90.9358L111.861 116.957Z"
          fill="#003381"
        />
        <path
          d="M139.292 77.9694L143.321 82.0277C144.204 82.917 144.204 84.3722 143.321 85.2614L137.687 90.9366L130.449 83.6446L136.083 77.9694C136.965 77.0801 138.41 77.0801 139.292 77.9694Z"
          fill="#0075C9"
        />
        <path
          d="M111.226 75.2952L112.315 75.7296C112.633 75.8668 112.633 76.3241 112.315 76.4385L111.226 76.8729C110 77.3531 109.047 78.3363 108.57 79.5482L108.139 80.6458C108.003 80.9659 107.549 80.9659 107.435 80.6458L107.004 79.5482C106.527 78.3135 105.551 77.3531 104.348 76.8729L103.259 76.4385C102.941 76.3013 102.941 75.844 103.259 75.7296L104.348 75.2952C105.574 74.815 106.527 73.8318 107.004 72.6199L107.435 71.5223C107.571 71.2022 108.025 71.2022 108.139 71.5223L108.57 72.6199C109.047 73.8546 110.023 74.815 111.226 75.2952V75.2952Z"
          fill="#FFC50A"
        />
        <path
          d="M104.734 101.299L107.231 102.282C107.957 102.58 107.957 103.631 107.231 103.906L104.734 104.889C101.965 105.987 99.7633 108.205 98.6739 110.994L97.6979 113.509C97.4028 114.241 96.3588 114.241 96.0864 113.509L95.1104 110.994C94.0209 108.205 91.8193 105.987 89.0502 104.889L86.5535 103.906C85.8272 103.609 85.8272 102.557 86.5535 102.282L89.0502 101.299C91.8193 100.202 94.0209 97.9835 95.1104 95.1939L96.0864 92.6787C96.3814 91.947 97.4255 91.947 97.6979 92.6787L98.6739 95.1939C99.7633 97.9835 101.965 100.202 104.734 101.299Z"
          fill="#FFC50A"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_7014_191886"
          x="0"
          y="0"
          width="192"
          height="192"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7014_191886"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7014_191886"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

HomePlannerIcon.propTypes = {
  percentage: PropTypes.string,
};

HomePlannerIcon.defaultProps = {
  percentage: '0%',
};

export default HomePlannerIcon;
